/**
 * Google AdSense setup. Ads stay completely off (no script, no empty boxes)
 * until `client` is set. Fill these in from your AdSense account:
 *   client: Account → Settings → Publisher ID, e.g. 'ca-pub-1234567890123456'
 *   slots:  Ads → By ad unit → create a Display ad unit for each placement, copy its data-ad-slot number
 * VITE_ADSENSE_CLIENT in the environment overrides `client` at build time.
 */
export const ADS = {
  client: (import.meta.env.VITE_ADSENSE_CLIENT as string | undefined) ?? 'ca-pub-8377375853111165',
  slots: {
    /** Game loading screen, under the Play button (every game opens here). */
    launch: '5454243826',
    /** Home page, below the game grid. */
    home: '4505133390',
    /** Bottom of the left sidebar (desktop). */
    sidebar: '8413333670',
    /** Game start screens (below the Start button). */
    setup: '4141162158',
    /** Below board games (under "How to play"). */
    board: '4200871902',
  },
  /**
   * Many players are children, so we ask Google for non-personalized ads only.
   * Also mark the site as child-directed in your AdSense / Google settings.
   */
  nonPersonalized: true,
  /**
   * Tag every ad request for child age treatment (AdSense "Tag for age treatment" = 1):
   * disables personalized ads and remarketing. Takes precedence over site-level settings.
   */
  childDirected: true,
  /**
   * Master switch for the ad units above. Keep false until AdSense shows the site
   * as "Ready" (approved): before that Google serves nothing and every slot would be
   * an empty "Advertisement" box. The publisher ID, ads.txt and policy text work either way.
   */
  showAds: false,
};

export type AdPlacement = keyof typeof ADS.slots;

export const adsEnabled = (): boolean => /^ca-pub-\d{10,20}$/.test(ADS.client);
export const slotFor = (p: AdPlacement): string => (adsEnabled() && ADS.showAds ? ADS.slots[p] : '');
